
import {MedicineTypeInfo} from "../models/Consultation";
import IDoctorProfile from "../models/IDoctorProfile"
import { ORION_IMG_URL, URLS } from "./AppConstants";

export const CDNUrl = URLS.CDN_URL;
export const CDNUrlForUploads = "https://s3.ap-south-1.amazonaws.com/cf-app-upload";

export default class AssetProvider {

    static getDoctorImage(doctorProfile: IDoctorProfile) {
        let imgUrl = doctorProfile.displayImage !== null ? this.getCDNAwareImgUrl(doctorProfile.displayImage) : ORION_IMG_URL + "default-user-image.png"
        return imgUrl;
    }

    static getCDNAwareImgUrl(imgUrl: string) {
        return CDNUrl + imgUrl;
    }

    static getCDNAwareImgUrlForUploads(imgUrl: string) {
        return CDNUrlForUploads + imgUrl;
    }

    static getMedicineTypeImage(medicineType: string, selected: boolean): string {
        let medicineTypeImagePrefix: string = "/images/icons/medicine-type/";
        let selectedSuffix: string = selected ? "-selected" : "";
        let imageType: string = ".svg";

        switch (medicineType) {
            case MedicineTypeInfo.SYRUP:
                return medicineTypeImagePrefix + "syrup" + selectedSuffix + imageType;
            case MedicineTypeInfo.INJECTION:
                return medicineTypeImagePrefix + "injection" + selectedSuffix + imageType;
            case MedicineTypeInfo.TABLET:
                return medicineTypeImagePrefix + "tablet" + selectedSuffix + imageType;
            case MedicineTypeInfo.CAPSULE:
                return medicineTypeImagePrefix + "capsule" + selectedSuffix + imageType;
            case MedicineTypeInfo.CREAM:
                return medicineTypeImagePrefix + "cream" + selectedSuffix + imageType;
            case MedicineTypeInfo.DROP:
                return medicineTypeImagePrefix + "drop" + selectedSuffix + imageType;
            case MedicineTypeInfo.SPRAY:
                return medicineTypeImagePrefix + "spray" + selectedSuffix + imageType;
        }
    }

    static getAppointmentIcon(type: string): string {
        let imagePrefix: string = ORION_IMG_URL + "icons/";
        let suffix: string = "";
        let imageType: string = ".png";
        let videoCameraImageType: string = ".svg";

        switch (type) {
            case "MISSED":
                return imagePrefix + "missed-call" + suffix + ".svg";
            case "FOLLOWUP":
                return imagePrefix + "follow-up-icon" + suffix + imageType;
            case "VIDEO":
                return imagePrefix + "video-camera" + suffix + videoCameraImageType;
        }
    }
}